// Query keys for the borrower's submitted FILE, as read by the report-request
// review panel.
//
// The file itself lives on the staged submission — the same row the review
// actions act on, whose id the item DTO now carries — so the preview reads
// `GET /collection/staging/{id}/download-url`, an endpoint that already exists
// and already serves the shared staging drawer. Nothing new was invented for
// it, and nothing here mutates: this is the PRESENTATION half of the staging
// module being reused, deliberately not its actions, which would file and
// approve the staged row while the report-request item stayed behind.
//
// Under the `collection-staging` prefix on purpose: every staging mutation
// invalidates that prefix, so a SAS URL cached here is dropped by the same
// writes that would invalidate it. (A separate prefix would keep serving an
// expired link after a re-upload.)

export const reportRequestPreviewKeys = {
  all: ["collection-staging", "download-url"] as const,
  submission: (stagedSubmissionId: string) =>
    ["collection-staging", "download-url", stagedSubmissionId] as const,
};
